<ng-container *transloco="let t">
  <section class="confirm-checkout-dot-com-container">
    <span class="fixed-space-8" aria-hidden="true"></span>
    <div class="flex justify-between align-end">
      <div class="flex flex-col">
        @for (product of products; track trackByItem(pos, product); let pos = $index) {
          <span class="small">{{ product.title || '' }}</span>
        }
      </div>
      <span class="fixed-space-4" aria-hidden="true"></span>

      <strong class="small"> {{ totalAmount | amount }}</strong>
    </div>
    <span class="fixed-space-4" aria-hidden="true"></span>
    <span class="line" aria-hidden="true"></span>
    <span class="fixed-space-4" aria-hidden="true"></span>

    <div class="flex justify-center">
      <button
        class="popsy-button-icon back-button"
        (click)="navigateToPaymentOverviewPage()">
        <popsy-icon-arrow-left-1 class="icon gray-01"></popsy-icon-arrow-left-1>
      </button>
      @if (!phoneNumberConfirmed()) {
        <h4 [class.title]="!(lessThan$ | async)?.md">STC Pay {{ t('label_phone') }}</h4>
      } @else {
        <h4 [class.title]="!(lessThan$ | async)?.md">
          {{ t('title_sms_sent', { var1: getMaskedNumber(modifiedPhoneNumber()) }) }}
        </h4>
      }
    </div>
    <span class="fixed-space-8" aria-hidden="true"></span>

    <!-- PHONE INPUT -->
    @if (!phoneNumberConfirmed()) {
      <section class="full-width popsy-input">
        <span>{{ t('msg_stc_phone') }} </span>
        <span class="fixed-space-12" aria-hidden="true"></span>
        <app-stc-phone-input
          data-clarity-unmask
          [country]="modifiedPhoneNumber()?.countryCode || 'SA'"
          [required]="true"
          [initialized]="false"
          [value]="modifiedPhoneNumber()"
          (debouncedPhoneNumberChange)="onPhoneChange($event)" />
      </section>
    } @else {
      <!-- OTP INPUT -->
      @if (!(lessThan$ | async)?.md) {
        <popsy-lottie-animation
          class="animation"
          [class.slim]="(lessThan$ | async)?.xs"
          animation="permission-notification"></popsy-lottie-animation>
      }

      <section class="full-width popsy-input formRow">
        <input
          [class.slim]="(lessThan$ | async)?.md"
          data-clarity-unmask
          id="otpInput"
          #otpInput
          type="tel"
          inputmode="tel"
          [placeholder]=""
          class="field otpInput"
          autocomplete="one-time-code"
          [formControl]="optFormControl"
          cdkTrapFocus
          [cdkTrapFocusAutoCapture]="true" />
        <span class="fixed-space-4" aria-hidden="true"></span>

        <span class="fixed-space-4" aria-hidden="true"></span>
        @if (!(requestingOtpAgain$ | async)) {
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="margin-0-auto"> {{ t('label_resend_sms') }}</span>
          <!-- REQUEST ANOTHER OTP -->
          <button
            [disabled]="requestingAgainCountdown$ | async"
            class="button popsy-button-primary"
            (click)="onCreatePaymentAgain()">
            <span> {{ t('action_request_otp') }} </span>
            @if (requestingAgainCountdown$ | async) {
              <span class="fixed-space-8" aria-hidden="true"></span>|
              <span class="fixed-space-8" aria-hidden="true"></span>
              <span>{{ requestingAgainCountdown$ | async }}</span>
            }
          </button>
        }
        @if (requestingOtpAgain$ | async) {
          <span class="text-highlight">
            {{ t('label_error_otp') }}
          </span>
        }
      </section>
    }
    <span class="fixed-space-32" aria-hidden="true"></span>

    <div class="floating-buttons">
      @if (!phoneNumberConfirmed()) {
        <!-- CONFIRM PHONE NUMBER -->
        <button
          class="button popsy-button-primary full-width"
          [disabled]="!modifiedPhoneNumber()"
          (click)="onConfirmPhoneNumber()">
          @if (processingPayment$ | async) {
            <app-loading class="spinner"></app-loading>
          }
          @if (!(processingPayment$ | async)) {
            <span>{{ t('action_continue') }}</span>
          }
        </button>
      } @else {
        @if (!(requestingOtpAgain$ | async)) {
          <!-- SEND THE OTP -->
          <button
            class="button popsy-button-primary full-width"
            [disabled]="!optFormControl.value"
            (click)="onContinuePressedWithLoop()">
            @if (processingPayment$ | async) {
              <app-loading class="spinner"></app-loading>
            }
            <span class="fixed-space-4" aria-hidden="true"></span>
            @if (!(processingPayment$ | async)) {
              <span> {{ t('action_validate_payment') }}</span>
            }
          </button>
        }

        @if (requestingOtpAgain$ | async) {
          <!-- REQUEST ANOTHER OTP -->
          <section>
            <button
              class="button popsy-button-primary full-width"
              (click)="onCreatePaymentAgain()">
              @if (processingPayment$ | async) {
                <app-loading class="spinner"></app-loading>
              }
              @if (!(processingPayment$ | async)) {
                <span>{{ t('action_request_otp') }}</span>
              }
            </button>
            <span class="fixed-space-16" aria-hidden="true"></span>
            <button
              class="button popsy-button-secondary full-width"
              (click)="navigateToPaymentOverviewPage()">
              @if (processingPayment$ | async) {
                <app-loading class="spinner"></app-loading>
              }
              @if (!(processingPayment$ | async)) {
                <span> {{ t('action_back_to_payment') }}</span>
              }
            </button>
          </section>
        }
      }
    </div>
  </section>
</ng-container>
